import { gql } from "@apollo/client";

export const GET_SHIPMENTS = gql`
  query GetShipments($query: QueryInput, $shipment: ShipmentInput) {
    shipments(query: $query, shipment: $shipment) {
      shipments {
        _id
        created_at
        updated_at
        number
        number_string
        type
        tracking_number
        encoded_label
        contact_id
        customer_id
        from {
          name
          company_displayable_name
          address1
          address2
          city
          state
          zip
        }
        to {
          name
          attention_name
          company_displayable_name
          address1
          address2
          city
          state
          zip
        }
        tickets {
          id
          number
          customer_id
          customer_business_then_name
          contact_id
          _id
        }
      }
      metaData {
        totalCount
        totalPages
        limit
      }
    }
  }
`;
